export default __webpack_public_path__ + "static/media/ic_export.b0b59f4f.svg";